module.exports = global["BVHOCs"] = require("-!/export/apps/mobile/node_modules/babel-loader/lib/index.js??ref--12-0!./hocs.js");